export default "__VITE_ASSET__DCPIfmpX__"